<template>
    <b-button 
        class='material-icons modal-btn' 
        variant="danger" 
        @click="touch()"
        :size="size"
    >
        delete_forever
    </b-button>

</template>

<script>
export default {
    name: 'arrayengineaddbutton',
    props:{
        touch: Function,
        size: {
            type: String,
            validator: (val) =>{
                // The value must match one of these strings
                return ['sm', 'md', 'lg'].indexOf(val) != -1
            },
            default: () => {return "md"}
        }
    },
}
</script>

<style>

</style>

